/**
 * @Author: Tom Voorneveld <tom>
 * @Date:   2019-01-18T13:15:00+01:00
 * @Email:  tom@lorinthe.com
 * @Project: Lorinthe
 * @Last modified by:   tom
 * @Last modified time: 2019-01-18T13:15:15+01:00
 * @Copyright: (c) copyright Lorinthe BV, all rights reserved
 */

export default function uppercase (input) {
  return input.toUpperCase()
}
